// i18n area 'networks' — locale es-ES (task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/networks.es-ES.meta.json.
import type { enUS } from './networks'

export const esES: typeof enUS = {
  networks: {
    common: {
      name: 'Nombre',
      scope: 'Scope',
      operState: 'Estado',
      actions: 'Acciones',
      create: 'Crear',
      close: 'Cerrar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      edit: 'Editar',
      save: 'Guardar',
      editError: 'Modificación fallida',
      search: 'Buscar por nombre',
      empty: 'Todavía nada aquí',
      saveError: 'No se pudo guardar',
      loadError: 'No se pudo cargar — ¿el backend TVirt es alcanzable?',
      createError: 'Creación fallida',
      deleteError: 'Eliminación fallida',
      deleteConfirmTitle: '¿Eliminar {name}?',
      deleteConfirmBody: 'La operación no es reversible.',
      nameHint: 'Minúsculas, cifras y guiones (DNS-1123)',
      up: 'Activa',
      down: 'No activa',
      unknown: 'Desconocido',
      usedByVMs: 'VM',
      emptyTable: 'Ninguna entrada — añada una con el botón +'
    },
    dialogTabs: {
      general: 'General',
      base: 'Definición base',
      advanced: 'Configuración avanzada',
      reserved: 'Rangos reservados a TVirt',
      position: 'Posición',
      network: 'Configuración de red',
      hosts: 'Nodos participantes'
    },
    reservedRanges: {
      note: 'Estos son los rangos de IP reservados a TVirt que puede usar para asignar automáticamente una dirección a VM, containers, etc. NOTA: las IP de estos rangos no deben usarse fuera de TVirt por servicios/aparatos externos.',
      from: 'Desde',
      to: 'Hasta'
    },
    overlay: {
      title: 'Redes overlay',
      createTitle: 'Crear red overlay',
      editTitle: 'Editar red overlay',
      vni: 'VNI',
      vniHint: 'VXLAN Network Identifier — asignado automáticamente si está vacío',
      subnet: 'Subnet',
      subnetHint: 'El CIDR de la overlay — el IPAM deriva automáticamente su entrada de registro',
      mtu: 'MTU',
      weight: 'Peso',
      ceilMbps: 'Techo (Mbps)',
      fairnessHint: 'El peso solo cuenta bajo contención: con el enlace libre cada red puede usar todo el ancho de banda. El techo, en cambio, siempre se aplica.',
      contention: 'Contención',
      contentionTip: 'Al menos un nodo observa descartes u overlimits CON cola en la clase de esta red: el ancho de banda del uplink está en disputa y los pesos actúan. Cuánto y desde cuándo están en las series net.shaping.* del nodo.',
      firewallPolicy: 'Política de firewall',
      hosts: 'Hosts',
      hostsTitle: 'Nodos participantes',
      hostsHint: 'Cada nodo declara su endpoint underlay — una select sobre las direcciones REALES del nodo, leídas de su configuración de red; la dirección overlay opcional debe estar dentro de la subnet. La participación es el vínculo de placement.',
      hostNode: 'Nodo',
      hostUnderlay: 'IP underlay',
      hostUnderlayPickNode: 'Elija primero el nodo',
      hostAddress: 'Dirección en la overlay (opcional)',
      hostAddressOutside: 'Fuera de la subred del overlay ({cidr})',
      addHost: 'Añadir nodo',
      observedAt: 'Observado el',
      attachedNics: 'NIC conectadas'
    },
    services: {
      title: 'Servicios de red',
      createTitle: 'Crear servicio de red',
      editTitle: 'Editar servicio de red',
      kind: 'Tipo',
      kindCategory: 'Servicios',
      selectKindHint: 'Elija el tipo de servicio — el demonio subyacente es un detalle de implementación que TVirt gestiona por usted.',
      kindLabel: {
        dhcp: 'Servidor DHCP',
        ntp: 'Servidor NTP',
        vpn: 'Servidor VPN',
        dns: 'Servidor DNS',
        gateway: 'Gateway',
        'lb-rp': 'Load balancer y reverse proxy',
        floatip: 'IP flotante'
      },
      kindDesc: {
        dhcp: 'Asigna direcciones en las subnets servidas — los pools derivan de la subnet, el gateway y los rangos reservados a TVirt de la red.',
        dns: 'DNS autoritativo sobre las zonas declaradas — los records derivan del IPAM más los suyos manuales.',
        gateway: 'El nodo hace de gateway para una red — NAT (DNAT, 1:1, SNAT/masquerade) más routing estático entre las redes conectadas, autorreparante por diseño.',
        'lb-rp': 'Balanceador / proxy inverso delante de tus servicios — listeners L4 o L7 sobre pools de miembros o sobre las instancias listas de un Pod, reconfigurados en caliente.',
        ntp: 'El servicio horario de las redes — relay de servidores upstream externos, o el reloj del nodo servido a los clientes.',
        vpn: 'Un concentrador VPN en el nodo — WireGuard u OpenVPN, usted elige: acceso remoto para clientes itinerantes, o un túnel site to site entre dos redes.',
        floatip: 'Una dirección que reside en UNA sola instancia App o Pod sana a la vez y se mueve al siguiente objetivo sano cuando cae — failover sin demonios; el balanceo queda en el balanceador.'
      },

      // Round Pod nativi P4: l'IP flottante (4b) e il backend Pod dell'lb-rp (4a).
      floatip: {
        hint: 'La IP flotante vive en la red elegida como dirección ADICIONAL dentro del espacio de nombres de la instancia titular: sin puertos, sin balanceo, sin NAT — la IP del cliente sigue siendo real.',
        address: 'IP flotante',
        targets: 'Objetivos',
        targetsHint: 'En orden de PREFERENCIA: el primer objetivo sano retiene la dirección. Un Pod vale por todas sus instancias, por réplica; cada objetivo tiene su propio criterio de salud. Cada objetivo debe estar conectado a la misma red.',
        targetKind: 'Objetivo',
        targetApp: 'Instancia App',
        targetPod: 'Pod (todas las instancias)',
        targetRef: 'Cuál',
        health: 'Salud',
        healthRunning: 'En ejecución (cada contenedor listo)',
        healthTcp: 'Conexión TCP',
        healthHttp: 'HTTP GET',
        healthPing: 'Ping',
        port: 'Puerto',
        path: 'Ruta',
        addTarget: 'Añadir objetivo',
        moveUp: 'Subir',
        moveDown: 'Bajar',
        preempt: 'Preempt',
        preemptHint: 'Desactivado (por defecto): un titular sano conserva la dirección aunque vuelva un objetivo superior — sin oscilaciones. Activado: el primer objetivo sano la retiene siempre.',
        holder: 'Titular',
        noHolder: 'ningún objetivo sano',
        since: 'desde',
        verdicts: 'Objetivos observados',
        healthy: 'sano',
        unhealthy: 'no sano',
        noVerdict: 'Aún sin decidir — el nodo autoridad escribe el primer veredicto en su próxima pasada.',
        vipChip: 'VIP {address}',
        vipChipTooltip: 'Esta instancia retiene la IP flotante {address} del servicio {service}'
      },
      poolSource: 'Endpoints',
      poolSourceMembers: 'Miembros estáticos',
      poolSourcePod: 'Las instancias listas de un Pod',
      poolBackendPod: 'Pod',
      poolBackendPort: 'Puerto',
      poolBackendHint: 'Los endpoints siguen al Pod: una instancia entra cuando está en ejecución con cada contenedor listo y sale de inmediato cuando se reduce o muere. La comprobación activa está activada por defecto.',
      poolBackendCount: 'las instancias listas del Pod {pod} en el puerto {port}',
      node: 'Nodo',
      enabled: 'Habilitado',
      parked: 'Aparcado',
      subnets: 'Subnets',
      subnetsHint: 'Las subnets IPAM servidas por esta instancia — los pools derivan del CIDR, el gateway y los rangos reservados a TVirt',
      noSubnets: 'Ninguna subnet IPAM — declare primero una red lógica de fabric (o una subnet overlay): el IPAM deriva de ellas',
      iface: 'Interfaz de escucha',
      ifaceHint: 'La interfaz del host en la que el servicio abre su socket (p. ej. un bridge) — obligatoria: un servicio de red es autocontenido, "todas las interfaces" ya no existe',
      dns: 'Servidores DNS',
      domain: 'Dominio',
      detail: 'Sirve',
      subnetCount: '{n} subnets',
      zones: 'Zonas',
      zonesHint: 'Solo autoritativo — el demonio nunca recurre. Los records A derivan de las direcciones declaradas de los nodos en las subnets IPAM referenciadas; el switch reverse sirve también las zonas in-addr.arpa correspondientes (PTR). Una zona es servida por como mucho una instancia DNS en la flota. El nameserver opcional es el FQDN escrito en los records NS/SOA en lugar del default ns.<zona>; si cae dentro de la zona, su record A deriva igualmente del nodo que la sirve.',
      zoneName: 'Nombre de la zona',
      zoneNs: 'Nameserver (NS)',
      zoneSubnets: 'Subnets IPAM',
      zoneReverse: 'Reverse (PTR)',
      zoneRecords: 'Records manuales',
      zoneRecordsHint: 'Uno por línea: nombre TIPO valor — tipos A, CNAME, MX, TXT. En caso de colisión en el nombre gana el record manual sobre el derivado.',
      addZone: 'Añadir zona',
      lbListeningHint: 'La instancia declara UNA red de escucha y UNA dirección — cada listener la enlaza en su propio puerto; una segunda dirección es un segundo servicio.',
      listeners: 'Listeners',
      listenersHint: 'Cada listener enlaza la dirección de la instancia en su propio puerto en modo L4 (passthrough TCP — los bytes nunca se abren) o L7 (HTTP) y reenvía a uno de los pools de abajo. Un par dirección/puerto lo sirve como máximo una instancia por nodo. Los cambios se aplican en vuelo — sin reinicio, sin conexiones perdidas.',
      listenerName: 'Nombre',
      listenerMode: 'Modo',
      modeL7: 'L7 — reverse proxy HTTP',
      modeL4: 'L4 — passthrough TCP',
      listenerPort: 'Puerto',
      listenerPool: 'Pool',
      addListener: 'Añadir listener',
      pools: 'Pools',
      poolsHint: 'Los backends donde aterriza el tráfico: miembros estáticos balanceados round-robin o por menos ocupado, con un health check activo opcional que saca de la rotación a los miembros enfermos.',
      poolName: 'Nombre',
      poolAlgorithm: 'Algoritmo',
      algoRoundRobin: 'Round robin',
      algoLeastRequest: 'Menos ocupado',
      poolCheck: 'Health check',
      checkNone: 'Ninguno',
      checkTcp: 'Conexión TCP',
      checkHttp: 'HTTP',
      poolCheckPath: 'Ruta de la sonda',
      poolInterval: 'Intervalo (s)',
      poolMembers: 'Miembros',
      poolMembersHint: 'Uno por línea: dirección:puerto, opcionalmente seguido de un peso (1-128) — p. ej. 10.0.0.21:8080 2',
      addPool: 'Añadir pool',
      memberCount: '{n} miembros',
      listen: {
        assignment: 'Asignación',
        assignmentStatic: 'Dirección estática',
        assignmentAuto: 'Automática (rangos reservados de TVirt)',
        autoHint: 'TVirt extrae la dirección de los rangos reservados de la red lógica y la mantiene sticky — nunca re-extraída en un edit o un failover.',
        title: 'Listeners',
        hint: 'Un servicio de red es autocontenido: cada listener declara su red (overlay, red lógica de fabric o interfaz) y una dirección dentro de su subred — un listener por dirección, el comodín ya no existe. DNS y NTP pueden escuchar en varias redes y varias direcciones de esas redes.',
        address: 'Dirección de escucha',
        add: 'Añadir listener'
      },
      ntp: {
        mode: 'Modo de sincronización',
        modeRelay: 'Relay de servidores externos',
        modeNodeClock: 'Reloj del nodo',
        modeHint: 'El relay sirve la hora tomada de los servidores upstream declarados; el reloj del nodo sirve la hora del nodo que lo aloja — que el clúster mantiene sincronizada de todos modos',
        servers: 'Servidores upstream',
        serversHint: 'Separados por coma — hostname o dirección IP; el servicio toma la hora de aquí y la sirve a la red',
        port: 'Puerto de escucha',
        listening: 'A la escucha en'
      },
      vpn: {
        engine: 'Motor',
        engineHint: 'Lo elige usted, y ya no cambia: WireGuard es moderno, rápido y en el kernel; OpenVPN es el veterano de la compatibilidad (TCP, redes hostiles)',
        engineLocked: 'El motor es inmutable — otro motor es un servicio nuevo, sus claves y certificados no son portables',
        mode: 'Modo',
        modeRemote: 'Acceso remoto',
        modeSite: 'Site to site',
        modeHint: 'El acceso remoto da a los clientes itinerantes una dirección en el túnel; el site to site une dos redes',
        port: 'Puerto de escucha',
        protocol: 'Transporte',
        protocolWireguardHint: 'WireGuard solo habla UDP',
        tunnelSubnet: 'Subnet del túnel',
        tunnelSubnetHint: 'La red en la que viven los clientes — registrada en el registro IPAM, nace y muere con este servicio',
        dnsServers: 'DNS empujados a los clientes',
        routes: 'Rutas empujadas a los clientes',
        routesHint: 'Redes separadas por comas alcanzables por el túnel; la subnet del túnel siempre está incluida',
        peers: 'Peers',
        peersHint: 'Deje vacía la clave pública y TVirt genera el par — luego lo entrega con el perfil. Pegue una clave y el peer conserva la suya.',
        clients: 'Clientes',
        clientsHint: 'Cada cliente recibe un certificado emitido por la CA propia de este servicio. Quitar un cliente lo REVOCA: la CRL se regenera de inmediato.',
        peerName: 'Nombre',
        publicKey: 'Clave pública',
        publicKeyMinted: 'La genera TVirt',
        peerAddress: 'Dirección en el túnel',
        peerAddressHint: 'Vacío = asignada',
        allowedIps: 'Subnets remotas',
        allowedIpsHint: 'Separadas por comas, enrutadas a través de este peer',
        endpoint: 'Endpoint',
        presharedKey: 'Clave precompartida',
        keepalive: 'Keepalive (s)',
        addPeer: 'Añadir peer',
        addClient: 'Añadir cliente',
        auth: 'Autenticación',
        authTls: 'Certificados (TLS)',
        remote: 'Endpoint remoto',
        remoteHint: 'host:puerto del extremo remoto — vacío significa que este lado espera',
        peerRoutes: 'Subnets remotas',
        serverPublicKey: 'Clave pública de este servidor',
        ca: 'Autoridad de certificación',
        listening: 'Escuchando en',
        tunnel: 'Túnel',
        peerCount: '{n} peers',
        download: 'Descargar perfil',
        downloadError: 'No se ha podido exportar el perfil',
        lastHandshake: 'Último handshake',
        never: 'nunca',
        traffic: '↓ {rx} · ↑ {tx}',
        connected: 'Conectado',
        idle: 'Inactivo'
      },
      gateway: {
        attach: 'Tipo de red de listening',
        attachOverlay: 'Red overlay',
        attachNetwork: 'Red lógica de fabric',
        attachInterface: 'Interfaz cruda',
        overlay: 'Red overlay',
        network: 'Red lógica',
        interface: 'Nombre de la interfaz',
        interfaceHint: 'Una interfaz del host que TVirt no gestiona — la dirección se da por buena',
        address: 'Dirección de listening (gateway)',
        addressHint: 'La dirección gateway a la que apuntan los clientes — dentro de la subnet de la red de listening',
        dnatTitle: 'Reglas DNAT',
        dnatHint: 'NAT de destino: el tráfico del match se redirige a una nueva dirección (y opcionalmente a un nuevo puerto). Cualquier protocolo de la lista — los puertos donde el protocolo los lleva.',
        snatTitle: 'Reglas SNAT',
        snatHint: 'NAT de origen: el tráfico del match sale con el origen reescrito — una nueva dirección explícita (y opcionalmente un nuevo puerto), o masquerade en la dirección de salida si se deja vacía.',
        oneToOneTitle: 'Reglas 1:1 NAT',
        oneToOneHint: 'Cada paquete hacia la dirección externa mapea a la interna, y el host interno sale como la externa — todos los protocolos, ambas direcciones.',
        external: 'Dirección externa',
        internal: 'Dirección interna',
        addOneToOne: 'Añadir regla 1:1',
        family: 'Familia',
        protocol: 'Protocolo',
        source: 'Origen (dirección/subnet)',
        destination: 'Destino (dirección/subnet)',
        invert: 'NOT',
        srcPorts: 'Puertos de origen',
        dstPorts: 'Puertos dest.',
        dstPortsHint: 'Puerto o rango (80, 8000-8099)',
        toAddress: 'Nueva dirección',
        toPort: 'Nuevo puerto',
        snatTo: 'Nuevo origen (vacío = masquerade)',
        snatToHint: 'Dirección de origen explícita; vacío = masquerade en la dirección de salida',
        addDnat: 'Añadir regla DNAT',
        addSnat: 'Añadir regla SNAT',
        routesTitle: 'Rutas estáticas',
        routesHint: 'El nodo enruta entre las redes a las que está conectado (el IP forwarding está activo); estas rutas añaden alcance más allá de ellas — kernel puro, el enrutamiento dinámico llega con una ronda posterior.',
        routeDestination: 'Subnet de destino',
        routeGateway: 'Next hop',
        routeMetric: 'Métrica',
        addRoute: 'Añadir ruta',
        listening: 'Escuchando en',
        rules: '{d} DNAT · {o} 1:1 · {s} SNAT · {r} rutas'
      },
      unknownSince: 'Desconocido — último report hace {m} min',
      lastWord: 'Última palabra',
      reportObservedAt: 'Último report',
      lastErrorRow: 'Último error',
      recordsCount: '{n} records manuales',
      phase: {
        configured: 'Configurado',
        running: 'En ejecución',
        error: 'Error'
      },
      authorityNode: 'Authority (asignación)',
      preferredNode: 'Nodo preferido',
      preferredNodeHint: 'Una preferencia blanda, nunca una restricción: en la próxima decisión de placement la instancia aterriza aquí si el miembro es elegible — por sí sola no mueve nada; el movimiento es "Transferir authority".',
      noPreference: 'Sin preferencia (placement automático)',
      moving: 'En movimiento',
      movingTooltip: 'Observado aquí mientras la authority asigna {node}: el movimiento está convergiendo.',
      placement: {
        title: 'Placement',
        loading: 'Censo en curso…',
        loadError: 'El censo de placement no ha respondido — vuelva a intentarlo más tarde.',
        draftHint: 'El censo se calcula sobre la conexión de red declarada: aparecerá con el servicio creado. La creación se rechaza si ningún miembro puede servirlo, y el rechazo nombra el mecanismo que vació el conjunto.',
        eligibleCount: '{n} de {m} miembros pueden servir esta instancia',
        recommended: 'Recomendado',
        eligible: 'Elegible',
        notEligible: 'No elegible',
        blockedReachability: 'la red no llega a este miembro',
        blockedRequireTag: 'bloqueado por un tag obligatorio (requireNodes)',
        blockedExcluded: 'excluido por la simulación',
        preferenceUnknown: 'no es (o ya no es) miembro del clúster',
        preferenceIgnored: 'La preferencia "{node}" hoy no es elegible: {reason}. Prevalece la recomendación del censo — nunca un error, el servicio vive en otra parte.',
        emptyReachability: 'Ningún miembro puede servir esta instancia: la red no llega a ninguna parte — ningún retoque de tags ayudará. Cablee el nodo, o mueva el servicio adonde la red sí está.',
        emptyRequireTag: 'Ningún miembro puede servir esta instancia: son los tags obligatorios los que vaciaron el conjunto — quite la entrada de requireNodes, o asigne el tag a un miembro.',
        spof: 'Punto único de fallo',
        spofDetail: 'Un solo miembro puede alojar la instancia: ante el fallo, el failover no tiene adónde ir. Un servicio multi-listener se mueve como UNIDAD — el candidato debe ver TODAS sus redes: ese es el coste.',
        whatIf: 'Simular miembros ausentes',
        whatIfHint: 'El what-if del drain: pregunte ANTES de la evacuación, no lo descubra en el failover.',
        survives: 'Con {nodes} ausente/s, el servicio todavía tiene una casa.',
        notSurvives: 'Evacuar {nodes} deja este servicio CAÍDO: la restricción derivada vence a la disponibilidad (R30) — un demonio vivo donde la red no llega no sirve a nadie y no alarma a nadie.',
        transfer: 'Transferir authority',
        transferError: 'La transferencia ha fallado',
        transferTarget: 'Miembro de destino',
        transferHint: 'Solo se proponen los miembros elegibles — una preferencia dentro del conjunto válido, nunca un override. Ningún task: el próximo paso de los workers ES el movimiento (el nodo viejo siega, el nuevo despliega).'
      }
    },
    fabric: {
      tabDerivation: 'Derivación',
      importNetwork: 'Importar de otra fabric',
      importTitle: 'Importar una red lógica',
      importHint: 'La importación es la adhesión explícita: la red sigue siendo del titular (misma identidad, mismo stem, mismo bridge tvf-<stem>) y desde aquí se mapea en los puertos/LAGG de esta fabric — mapear ES afirmar que la entrega desemboca en el mismo dominio L2 que la del titular.',
      importPick: 'Red del titular',
      importNone: 'Nada que importar: las otras fabric no tienen ninguna red propia que esta fabric no conozca ya',
      importedNetworksTitle: 'Redes importadas',
      noImported: 'Ninguna red importada',
      importedFrom: 'importada de {fabric}',
      importedBy: 'Importada por: {list}',
      importedCount: '+{n} importadas',
      owner: 'Titular',
      bridge: 'Bridge',
      bond: 'Bond',
      unimport: 'Quitar la importación',
      unimportConfirm: '¿Quitar la importación de la red {name} (titular {fabric}) de esta fabric? Se rechaza mientras un puerto o LAGG de esta fabric la mapee, o un guest, App o servicio se sirva solo a través de esta pata.',
      unimportRefused: 'Importación aún en uso — {detail}',
      deriv: {
        codeHint: {
          deviceHeldByFabric: 'Este nodo ya toma esa red de otra fabric de la que es miembro: un nodo toma una red compartida por UNA sola de sus patas (dos uplinks del mismo L2 en un bridge sin STP son un bucle). Desmapéala en los puertos o en el LAGG de una de las dos fabric.',
          otherFabricDerived: 'El documento lleva el bloque de una fabric hacia la que el nodo ya no declara ningún cable: aplica primero el plan de esa fabric (propone quitar sus dispositivos), o tómalos con take-ownership si la fabric ya no existe.'
        },
        hint: 'El plan de derivación O.3: para cada nodo cableado el estado, el diff derivado-vs-actual, la topología de bond DECLARADA, los flips dual-stack y los rechazos/avisos estructurados. Solo lectura hasta el apply EXPLÍCITO — nada aterriza nunca solo en un nodo.',
        refresh: 'Recargar el plan',
        empty: 'Ningún nodo está cableado a esta fabric (y ninguno lleva todavía su bloque).',
        refusal: 'Rechazo',
        warning: 'Aviso',
        generation: 'generación del documento {n}',
        state: {
          manual: 'Manual',
          derived: 'Derivado',
          diverged: 'Divergente'
        },
        topologyTitle: 'Topología declarada',
        members: 'miembros',
        primary: 'primaria',
        held: 'retenido en UN solo miembro',
        form: {
          perNetworkBond: 'Bond por red',
          singleBond: 'Bond único de repliegue',
          laggBond: 'Bond LACP (LAGG)',
          singlePort: 'Puerto único'
        },
        colAction: 'Acción',
        colKind: 'Tipo',
        colDevice: 'Device',
        colDetail: 'Detalle',
        action: {
          add: 'añadir',
          remove: 'quitar',
          replace: 'sustituir'
        },
        diffEmpty: 'Ningún diff pendiente — el documento aplicado coincide con el render.',
        diffBlocked: 'Ningún diff: los rechazos de arriba bloquean este nodo.',
        phasePlanned: 'planificado (paso 1 de 3)',
        phaseDraining: 'en drenaje (paso 2 de 3)',
        probeUnobserved: 'Sonda de drenaje: nunca reportada — el vacío es DESCONOCIDO (un retiro ahora sería rechazado).',
        probeFailed: 'Sonda de drenaje: observación FALLIDA — los timestamps conocidos se arrastran, nunca un «vacío» que nadie midió.',
        probeActive: {
          one: 'Sonda: {n} conexión establecida aún en la dirección vieja',
          many: 'Sonda: {n} conexiones establecidas aún en la dirección vieja',
          other: 'Sonda: {n} conexiones establecidas aún en la dirección vieja'
        },
        probeLastActive: 'última actividad {time}',
        probeEmpty: {
          one: 'Sonda: vacío desde hace {n} minuto',
          many: 'Sonda: vacío desde hace {n} minutos',
          other: 'Sonda: vacío desde hace {n} minutos'
        },
        probeEmptyUnknown: 'Sonda: vacío (desde cuándo, desconocido).',
        impact: '{nics} vNIC y {apps} App en este nodo usan estas redes: {list}',
        apply: 'Aplicar en este nodo',
        applyTitle: 'Aplicar la derivación — {node}',
        applyIntro: 'La configuración derivada reescribe el documento de red de {node} ({n} cambios) por la misma puerta que el editor host-network — checkpoint de NetworkManager y probe honesta incluidos. Los avisos del plan de abajo viajan con el acto: léelos antes de confirmar.',
        applyError: 'Apply fallido',
        applyRefused: 'El nodo rechazó:',
        planMoved: 'La fabric cambió después de esta vista previa — NADA fue aplicado. El plan se ha recargado: mira de nuevo y reintenta.',
        retire: 'Retirar',
        retireTitle: 'Punto de no retorno — retiro de {address}',
        restore: 'Restaurar',
        restoreTip: 'Volver a la instantánea previa al apply (generación {previous}) — el deshacer de un paso (H13)',
        restoreTitle: 'Restaurar el documento anterior — {node}',
        restoreIntro: 'El documento de red de {node} vuelve a la instantánea tomada antes del último apply (generación {previous}), reescrita como generación {next} en lugar de la {current}. El worker la converge como cualquier otro documento.',
        restoreRedo: 'El documento reemplazado se convierte en la nueva instantánea: restaurar de nuevo es el rehacer.',
        restoreClosesChain: 'La instantánea es el documento manual previo a la derivación: la cadena se cierra aquí — sin más deshacer, el nodo queda manual hasta el próximo apply.',
        restoreConfirm: 'Restaurar',
        restoreError: 'Restauración fallida',
        retireIntro: 'Esto quita {address} ({network}) de {point} definitivamente. Después de este acto el camino de vuelta es el flip INVERSO — redeclarar la dirección vieja por el mismo motor — nunca una restauración ciega.',
        retireOld: 'Dirección vieja (quitada)',
        retireNew: 'Dirección nueva (se queda)',
        retireEmptyFact: 'La sonda da la dirección vacía: este retiro no corta ninguna conexión observada.',
        retireConfirm: 'Retirar la dirección',
        severActiveLoss: {
          one: 'Cortar {n} conexión establecida aún en la dirección vieja — muere con este acto',
          many: 'Cortar {n} conexiones establecidas aún en la dirección vieja — mueren con este acto',
          other: 'Cortar {n} conexiones establecidas aún en la dirección vieja — mueren con este acto'
        },
        severUnknownLoss: 'Aceptar lo DESCONOCIDO: la sonda nunca observó esta dirección (o la observación falla) — conexiones vivas pueden ser cortadas.'
      },
      title: 'Fabric',
      createTitle: 'Crear fabric',
      networks: 'Redes',
      switches: 'Switches',
      ports: 'Puertos',
      laggs: 'LAGGs',
      subnets: 'Subnets',
      tabOverview: 'Vista general',
      tabNetworks: 'Redes lógicas',
      tabSwitches: 'Switches',
      overviewHint: 'La fabric de un vistazo: cada red lógica con MTU y subnet (las VLAN viven solo en los mapeos por puerto/por LAGG — la misma red puede viajar con tags distintos en puertos distintos). La fabric es el registro de una infraestructura EXTERNA — TVirt observa y declara, nunca hace provisioning, y toca solo las NIC registradas bajo su control.',
      absorptionHint: 'Cada subnet declarada aquí DERIVA su entrada en el registro IPAM en la misma escritura — vive y muere con la red.',
      scopeFixedHint: 'El scope es fijo en la raíz del clúster: la infraestructura física es, por definición, de todo el clúster.',
      networksHint: 'Cada red lleva una MTU obligatoria (default 1500) y una subnet obligatoria; gateway, servidores DNS y rutas estáticas declarados aquí son la FUENTE ÚNICA para las NIC de los servidores, las Apps y los servicios de red.',
      switchesHint: 'El registro manual: un puerto está no usado, mapeado (tráfico untagged y por VLAN tag hacia las redes lógicas) o es miembro de un LAGG — un miembro no lleva mapeos propios.',
      mtu: 'MTU',
      cidr: 'CIDR',
      cidrHint: 'Obligatorio — el IPAM deriva automáticamente su entrada de registro',
      nodeAddressing: 'Direccionamiento de nodos',
      nodeAddressingNone: 'Ninguno — sin dirección por nodo',
      nodeAddressingPool: 'Pool — una dirección fija por nodo servido',
      nodeAddressingHint: 'Con Pool, la derivación del fabric asigna a cada nodo servido una dirección de los rangos reservados a TVirt (fija una vez asignada).',
      backing: 'Backing',
      gateway: 'Gateway',
      ranges: 'Rangos reservados',
      dns: 'Servidores DNS (separados por coma)',
      dnsShort: 'DNS',
      singleSourceHint: 'Gateway, DNS y rutas declarados aquí son la fuente única — las NIC de los servidores, las Apps y los servicios de red beben de aquí',
      routesTitle: 'Rutas estáticas',
      routeDestination: 'Destino (CIDR)',
      routeVia: 'Vía (next hop)',
      portUsed: 'Usado',
      vlanMappings: 'Mapping VLAN',
      vlanTag: 'Tag VLAN',
      vlanNetwork: 'Red lógica',
      nameTaken: 'Nombre ya usado en la fabric',
      addNetwork: 'Añadir red',
      editNetwork: 'Editar red',
      deleteNetwork: 'Quitar red',
      deleteNetworkConfirm: '¿Quitar la red lógica {name} de la fabric? Su subnet derivada en el IPAM muere con ella (rechazado mientras un servicio o una App la use). Los mapeos de puertos y LAGG que la referencian se limpian.',
      switchName: 'Switch',
      portName: 'Puerto',
      positionHint: 'Posición física (opcional) — el mismo vocabulario que el emplazamiento de los servidores; solo declarativa',
      addSwitch: 'Añadir switch',
      editSwitch: 'Editar switch',
      deleteSwitch: 'Quitar switch',
      deleteSwitchConfirm: '¿Quitar el switch {name} con todos sus puertos? Los LAGGs se encogen en consecuencia (y mueren por debajo de dos puertos).',
      addPort: 'Añadir puerto',
      editPort: 'Editar puerto',
      deletePort: 'Quitar puerto',
      deletePortConfirm: '¿Quitar el puerto {name}?',
      untagged: 'Untagged',
      tagged: 'Tagged (tag:red)',
      taggedShort: 'Tagged',
      portCabling: 'Cableado',
      portState: 'Estado',
      stateUnused: 'no usado',
      stateMapped: 'mapeado',
      laggPortGuard: 'Un puerto miembro de un LAGG se edita desde el lado LAGG',
      laggsTitle: 'LAGGs',
      laggsHint: 'Un LAGG son 2+ puertos en LACP y puede atravesar switches (MLAG, transparente); entran solo puertos no usados, el LAGG es la superficie de mapeo, un puerto quitado vuelve a no usado.',
      addLagg: 'Añadir LAGG',
      editLagg: 'Editar LAGG',
      deleteLagg: 'Quitar LAGG',
      deleteLaggConfirm: '¿Quitar el LAGG {name}? Sus puertos miembros vuelven a no usados.',
      lacpRate: 'Rate LACP',
      laggPorts: 'Puertos miembros (2+)',
      laggPortsHint: 'Entran solo puertos no usados — libere primero un puerto mapeado',
      noNetworks: 'Ninguna red lógica declarada.',
      noSwitches: 'Ningún switch declarado.',
      noLaggs: 'Ningún LAGG declarado.',
      staleConflict: 'Otro operador ha modificado esta fabric mientras la estabas editando: el guardado se ha rechazado para no borrar su trabajo. Tus cambios siguen aquí, intactos. La fabric actualizada ya se ha recargado: confirma de nuevo para volver a aplicarlos encima, o cancela y mira qué ha cambiado.'
    },
    ipam: {
      title: 'IPAM',
      derivedHint: 'Solo derivado: cada subnet nace de una red lógica de fabric o de una overlay — se edita en su origen. Las direcciones asignadas muestran QUIÉN las tiene; los rangos reservados a TVirt son los pools de la asignación automática.',
      search: 'Buscar por nombre, CIDR o dirección',
      empty: 'Ninguna red — declare una red lógica de fabric o una subnet overlay: el IPAM deriva de ellas automáticamente.',
      reserved: 'Rangos reservados a TVirt',
      address: 'Dirección',
      origin: 'Procedencia',
      origin_declared: 'declarada',
      origin_observed: 'observada',
      holder: 'En manos de',
      noAddresses: 'Ninguna dirección conocida en esta subnet.',
      sourceFabric: 'Fabric',
      sourceOverlay: 'Overlay',
      editAtSource: 'Editar en el origen'
    },
    firewall: {
      title: 'Grupos de firewall',
      createTitle: 'Nuevo grupo de firewall',
      editTitle: 'Editar grupo de firewall',
      empty: 'Ningún grupo de firewall — cree uno: un vocabulario de reglas reutilizable, referenciado por las NIC de invitado por su nombre.',
      nameHint: 'Letras, cifras y . - _ interiores; único dentro de su scope (los homónimos de otros sitios se distinguen con /scope/nombre)',
      description: 'Descripción',
      descriptionHint: 'Una línea de intención, mostrada allí donde se elige el grupo',
      enforced: 'Impuesto al scope',
      enforcedHint: 'Apagado: vocabulario puro — las reglas vinculan solo las NIC que referencian el grupo. Encendido: las reglas vinculan cada NIC de invitado con el firewall encendido bajo el scope del grupo, referenciadas o no.',
      enforcedChip: 'Impuesto',
      enforcedChipHint: 'Las reglas vinculan cada NIC de invitado con el firewall encendido bajo el scope del grupo, referenciadas o no',
      enforceWarning: 'Al activar la imposición las reglas vinculan CADA NIC de invitado con el firewall encendido bajo {scope} en la próxima alineación, incluso sin referencia explícita — y dentro de una chain activa el drop de un ancestro es definitivo: los niveles inferiores no lo reabren.',
      unenforceInfo: 'Al quitar la imposición las reglas quedan solo en las NIC que referencian el grupo explícitamente.',
      rules: 'Reglas',
      tabOverview: 'Vista general',
      tabRules: 'Reglas',
      orderHint: 'El orden de las filas ES el orden de evaluación dentro del grupo: gana la primera regla que coincide.',
      statefulHint: 'Lo stateful es implícito: las respuestas al tráfico admitido pasan solas (established/related aceptadas, invalid descartado — las inyecta el motor, no se escriben a mano).',
      noRules: 'Ninguna regla — un vocabulario en construcción: referenciarlo es lícito y no renderiza nada.',
      addRule: 'Añadir regla',
      direction: 'Dirección',
      directionIn: 'Entrante',
      directionOut: 'Saliente',
      action: 'Acción',
      action_accept: 'Aceptar',
      action_drop: 'Descartar',
      action_reject: 'Rechazar',
      protocol: 'Protocolo',
      protocolAny: 'Cualquiera',
      ports: 'Puertos',
      source: 'Origen',
      dest: 'Destino',
      comment: 'Comentario',
      addressHint: 'CIDR IPv4 o <fabric>/<red lógica>; vacío = cualquiera',
      moveUp: 'Subir',
      moveDown: 'Bajar',
      nicFirewall: 'Firewall',
      nicAntiSpoof: 'Anti-spoofing',
      nicGroups: 'Grupos de firewall',
      nicGroupsPlaceholder: 'Elija un grupo…',
      nicGroupsHint: 'Los grupos visibles, incluidos los de los scopes superiores (utilizables hacia abajo, como los tags)',
      nicGroupCount: { one: '{n} grupo de firewall', many: '{n} grupos de firewall', other: '{n} grupos de firewall' },
      nicOff: 'Firewall apagado',
      pendingRestartHint: 'Los cambios de firewall siguen el modelo guardado/aplicado: esperan al próximo power cycle (PendingRestart). Los grupos impuestos por los scopes superiores se aplican cuando el firewall de la NIC está encendido.',
      appConvergeHint: 'Los cambios de firewall se aplican en la próxima alineación del container. Los grupos impuestos por los scopes superiores se aplican cuando el firewall está encendido.',
      enforcedAncestors: 'Impuestos por los scopes superiores',
      enforcedAncestorsHint: 'Este grupo se aplica a cada NIC bajo su scope con el firewall ENCENDIDO — el toggle es el interruptor general de la NIC (apagado = ninguna chain, ancestros incluidos); dentro de una chain activa la autoridad del ancestro es definitiva: su drop no se reabre debajo.'
    }
  }
}
